<!--
 * @Author: Gaho
 * @Date: 2024-03-19 15:30:26
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-16 15:29:42
 * @Description: 
-->
<template>
    <div class="relative py-4 flex w-full justify-center">
        <!-- 单局 -->
        <div 
            class="content" 
            :class="{ 'lost': !history.winAmount }"
            v-if="history.single"
        >
            <span class="label">
                {{ history.winAmount ? $t('win') : $t('lose') }}
            </span>
            <div 
                class="coin"
                :class="history.randomSeed.slice(0, 1) === '1' ? 'coin-head' : 'coin-tail'"
            ></div>
        </div>
        <!-- 多局 -->
        <div v-else class="content-multiply">
            <div v-for="(item, index) in history.state" :key="item.hash" class="multiply-item">
                <span>
                    {{ index === 0 ? $t('firstSide') : getFixed(item.multi) }}
                </span>
                <div 
                    class="multiply-coin" 
                    :class="{ 'selectd': currentIndex === index, 'lost': !item.multi }"
                    @click="() => emit('handleSelectItem', index)"
                >
                    <div 
                        class="coin coin-small"
                        :class="item.seed.slice(0, 1) === '1' ? 'coin-head' : 'coin-tail'"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
    currentIndex: {
        type: Number,
        default: 0
    }
})
const emit = defineEmits(['handleSelectItem']);

</script>
<style lang="scss" scoped>
.content, .content-multiply {
    display: flex;
    flex-direction: column;
    .label {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 15px;
        text-align: center;
        color: #2281f6;
    }
    .coin {
        background-size: 130px;
        height: 130px;
        position: relative;
        width: 130px;
        border-radius: 50%;
        background-position: 50%;
        background-repeat: no-repeat;
    }
    .coin-small {
        background-size: 80px;
        cursor: pointer;
        height: 80px;
        width: 80px;
    }
    .coin-head {
        background-image: url('@/assets/webp/coin-head.webp');
    }
    .coin-tail {
        background-image: url('@/assets/webp/coin-tail.webp');
    }
}
.lost {
    .label {
        color: #fa305c;
    }
    .coin {
        opacity: .5;
    }
}
.content-multiply {
    width: 100%;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 20px;
    flex-direction: row;
    .multiply-item {
        align-items: center;
        display: flex;
        flex-direction: column;
        margin-right: 15px;
    }
    span {
        color: var(--color_green);
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 15px;
        min-width: 40px;
        text-align: center;
    }
    .multiply-coin {
        border: 2px solid transparent;
        border-radius: 50%;
        padding: 2px;
        position: relative;
    }
    .selectd {
        border-color: #0bb85a;
        &::after {
            border: 12px solid rgba(11,184,90,0);
            border-top-color: #0bb85a;
            content: " ";
            height: 0;
            left: 50%;
            margin-left: -12px;
            pointer-events: none;
            position: absolute;
            top: calc(100% + 7px);
            width: 0;
        }
    }
}
</style>